import React, { Component, Fragment } from 'react';
import cn from 'classnames';
import { bool, string, oneOf } from 'prop-types';
import CustomTableWrapper from './CustomTableWrapper';
import CustomTableRow from './CustomTableRow';
import CustomTableCell from './CustomTableCell';
import CustomTablePlaceholder from './CustomTablePlaceholder';

class CustomTable extends Component {
  static propTypes = {
    layout: oneOf(['auto', 'fixed']),
    className: string,
    responsive: bool,
    bordered: bool,
    stripped: bool,
    condensed: bool,
  };

  static defaultProps = {
    responsive: false,
    bordered: true,
    stripped: false,
    condensed: false,
    layout: 'auto',
  };

  static Wrapper = CustomTableWrapper;
  static Row = CustomTableRow;
  static Cell = CustomTableCell;
  static Placeholder = CustomTablePlaceholder;

  render() {
    const {
      layout,
      bordered,
      stripped,
      responsive,
      condensed,
      children,
      className,
      sortBy,
      sortOrder,
      sortName,
      handleSort,
      sorting,
      defaultSortOrder,
      ...rest
    } = this.props;
    const tableClasses = cn('custom-table', className, {
      'custom-table-bordered': bordered,
      'custom-table-stripped': stripped,
      'custom-table-condensed': condensed,
      'table-layout-fixed': layout === 'fixed',
    });

    return (
      <Fragment>
        {responsive ? (
          <div className="table-responsive">
            <div className={tableClasses} role="table" {...rest}>
              {children}
            </div>
          </div>
        ) : (
          <div className={tableClasses} role="table" {...rest}>
            {children}
          </div>
        )}
      </Fragment>
    );
  }
}

export default CustomTable;
